import { ColumnDef } from '@tanstack/react-table'
import { IParty, IRenderInputs } from '../models/models'
import dateFormat from 'dateformat'
import { ReactComponent as SuccessIcon } from '../assets/icons/success.svg'
import { ReactComponent as WarningIcon } from '../assets/icons/warning.svg'
import SliderModal from '../components/UI/SliderModal'
import { getPartyFilesLinks } from '../helpers'

export const partiesColumns: ColumnDef<IParty>[] = [
	{
		accessorKey: 'id',
		header: 'id партії',
		enableSorting: false,
	},
	{
		accessorKey: 'parentPartyId',
		header: 'id партії звідки перелили',
		enableSorting: false,
	},
	{
		accessorKey: 'datetime',
		header: 'Дата',
		cell: (value) => dateFormat(value.row.original.datetime, 'dd.mm.yyyy'),
	},
	{
		accessorKey: 'datetime2',
		header: 'Час',
		cell: (value) => dateFormat(value.row.original.datetime, 'HH:MM'),
		enableSorting: false,
	},
	{
		accessorKey: 'number',
		header: 'Номер транспорту',
		enableSorting: false,
	},
	{
		accessorKey: 'productName',
		header: 'Назва товару',
		enableSorting: false,
	},
	{
		accessorKey: 'density',
		header: () => (
			<>
				Густина <br />
				кг/м³
			</>
		),
		enableSorting: false,
	},
	{
		accessorKey: 'temperature',
		header: () => (
			<>
				Температура <br />
				°C
			</>
		),
		enableSorting: false,
	},
	{
		accessorKey: 'volume',
		header: () => (
			<>
				Об’єм <br />
				дм³
			</>
		),
		enableSorting: false,
	},
	{
		accessorKey: 'volumeStableDegree',
		header: () => (
			<>
				Об’єм при <br />
				15°C дм³
			</>
		),
		enableSorting: false,
	},
	{
		accessorKey: 'mass',
		header: () => (
			<>
				Маса <br />
				кг
			</>
		),
		enableSorting: false,
	},
	{
		accessorKey: 'files',
		header: 'Прикріплені файли',
		enableSorting: false,
		cell: (value) => <SliderModal files={getPartyFilesLinks(value.row.original)} />,
	},
	{
		accessorKey: 'confirmed',
		header: '',
		enableSorting: false,
		cell: (value) => (value.row.original?.confirmed ? <SuccessIcon /> : <WarningIcon width={27} height={27} />),
	},
]

export const partiesInputsData: IRenderInputs<IParty>[] = [
	{
		name: 'productName',
		type: 'text',
		placeholder: 'Назва товару',
	},
	{
		name: 'density',
		type: 'number',
		placeholder: 'Густина, кг/м³',
	},
	{
		name: 'temperature',
		type: 'number',
		placeholder: 'Температура, °C',
	},
	{
		name: 'volume',
		type: 'number',
		placeholder: 'Об’єм, дм³',
	},
	{
		name: 'volumeStableDegree',
		type: 'number',
		placeholder: 'Об’єм при 15°C, дм³',
	},
	{
		name: 'mass',
		type: 'number',
		placeholder: 'Маса, кг',
	},
	{
		name: 'primePrice',
		type: 'number',
		placeholder: 'Собівартість літра',
	},
	{
		name: 'fuelOwner',
		type: 'text',
		placeholder: 'Власник палива',
	},
	{
		name: 'comment',
		type: 'text',
		placeholder: 'Коментар',
	},
]
